import { Tareas } from "./Tareas";
import {MyNavbar} from "../elementos/Navbar";

export const Home = () => {
  return (
    <div className="div-global" style={{ padding: "0" }}>

        <MyNavbar/>

      <div
        className="div-titulo"
        style={{ paddingLeft: "5%", paddingRight: "5%" }}
      >
        <h1
          className="text-center-tt"
          style={{ marginTop: "5%", marginBottom: "5%" }}
        >
          Bienvenido a la Aplicación de Tareas
        </h1>

        <Tareas />
      </div>
    </div>
  );
};
